const KEYS = {
  // LOGIN_USER: 'LUT',
  // LOGIN_TOKEN: 'LUT_TK',
  LANG: "LANG",
};
export { KEYS };
